import { Injectable } from '@angular/core';
import { ApplicationProxyService } from './applicationproxy.service';

@Injectable()
class BadWordsService {
  constructor(applicationProxy: ApplicationProxyService) {
    this.appProxy = applicationProxy;
  }

  getBadWords() {
    // bad words service call here....(get)
    return this.appProxy.getWords()
      .then(res => {
        const regEx = this.buildRegEx(res);
        const namesRegEx = this.buildRegEx(res, true);
        return { regEx, namesRegEx };
      })
      .catch(err => console.error('getBadWords Error', err));
  }

  buildRegEx(words, nameRegex = false) {
    let wordCheckRegex = null;
    let wordList;
    if (words) {
      // check word boundary matches
      wordList = words.base;
      if (nameRegex) {
        // remove names from invalid strings.
        const nameList = words.names;
        wordList = wordList.filter((w) => !nameList.includes(w));
      }
      let regexString = `\\b${wordList.join('\\b|\\b')}\\b`;
      const substringList = words.substring;
      if (substringList) {
        // check for substrings if it's present in the json payload
        regexString += `|${substringList.join('|')}`;
      }
      wordCheckRegex = new RegExp(regexString, 'gi');
      return wordCheckRegex;
    }
    return false;
  }
}
export { BadWordsService };
